import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';

export interface ISignUpValidationInput {
    organizationName: string;
    email: string;
    captchaToken: string;
}

export interface ISignUpValidationResponse {
    matchingOrganizations: any[];
    validEmail: boolean;
    validOrgName: boolean;
    validCaptcha: boolean;
}

const signUpUserAndOrgValidate = async (signupData: ISignUpValidationInput): Promise<ISignUpValidationResponse> => {
    const response = await axiosInstance.post(`${API_ENDPOINTS.SIGNUP.USER_AND_ORG_VALIDATE}`, signupData);
    return response.data;
};

export const useSignUpUserAndOrgValidate = () => useMutation<ISignUpValidationResponse, unknown, ISignUpValidationInput>({
    mutationFn: signUpUserAndOrgValidate,
});

export default useSignUpUserAndOrgValidate;
